import { render, staticRenderFns } from "./recent-assets.vue?vue&type=template&id=28477ee5&scoped=true&"
import script from "./recent-assets.vue?vue&type=script&lang=ts&"
export * from "./recent-assets.vue?vue&type=script&lang=ts&"
import style0 from "./recent-assets.vue?vue&type=style&index=0&id=28477ee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28477ee5",
  null
  
)

export default component.exports